<template>
  <v-btn
    small
    depressed
    dark
    v-if="create"
    v-bind="buttonProperties"
    :color="color"
    :to="route"
    :href="href"
    :disabled="disabled"
    :target="linkTarget"
    @click.native="onClick"
  >
    <v-icon v-if="icon" left>{{icon}}</v-icon>
    <span>{{ label|t }}</span>
  </v-btn>
</template>

<script lang="babel" type="text/babel">
import listActionMixins from '@/components/list/listDataAction/listDataAction.js'
export default {
  mixins: [listActionMixins],
}
</script>

<style lang="sass" type="text/sass" scoped></style>
